module.exports = __webpack_public_path__ + "img/lfa.e3f1fa7.png";